module.exports = __webpack_public_path__ + "img/кнопка действия.39706b86.svg";